export class BaseService{
  public  url:any

     // ESealStore_Java
     // esealstore
  //--proxy-config proxy.conf.json 
     }



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/BaseService.ts